import React, { ReactElement, useEffect, useState } from 'react';
import { DateInput, Alert, TileRadioAccessible, ReviewAccordionFooter } from '@components';
import { Field, getIn, useFormikContext } from 'formik';
import { tile } from '@interfaces/interfaces';
import { iReviewFormValues } from '@services/ReviewService';

import gridStyles from '@pages/forms/Grid.module.scss';
import InfoIcon from '../../../../../images/info.svg';
import ErrorIcon from '../../../../../images/issue.svg';
import styles from './Step6Grounds.module.scss';

const PERSON_UNAWARE_FIELD_NAME = 'SelectedGroundInfo3';
const FIELD_NAME = 'selectTheOption';

const PersonUnawareContent = (): ReactElement => {
  const { errors, touched, values }: { errors:any, touched: any, values: iReviewFormValues } = useFormikContext();
  const [personUnawareErrorCount, setpersonUnawareErrorCount] = useState(0);
  const [errorsBlockingSelection, setErrorsBlockingSelection] = useState(false);
  const formikContext = useFormikContext();
  const olderThan15Days = new Date(new Date().setDate(new Date().getDate() - 15));

  const TILE_DATA: tile[] = [
    {
      body: 'Yes',
      value: 'true',
    },
    {
      body: 'No',
      value: 'false',
    },
  ];
  useEffect(() => {
    formikContext.setFieldValue('errorOrInfoAppearsInAccordion', personUnawareErrorCount);
    if (values.personUnawareWasSomeoneElseDriving === 'true'
    || (values.personUnawareFindOutDate !== null
    && (values.personUnawareFindOutDate < olderThan15Days || values.personUnawareFindOutDate > new Date()))) {
      if (getIn(values, FIELD_NAME).includes(PERSON_UNAWARE_FIELD_NAME)) formikContext.setFieldValue(FIELD_NAME, []);
      setErrorsBlockingSelection(true);
      }
    if (values.personUnawareWasSomeoneElseDriving === 'false'
      && values.personUnawareFindOutDate !== null
      && values.personUnawareFindOutDate > olderThan15Days
      && values.personUnawareFindOutDate <= new Date()
    ) setErrorsBlockingSelection(false);
    setpersonUnawareErrorCount(personUnawareErrorCount + 1);
  },
  [
    values.personUnawareFindOutDate,
    values.personUnawareCanUploadSupportingDocs,
    values.personUnawareEnforcementHappened,
    values.personUnawareWasSomeoneElseDriving,
  ]);

  const personUnawareDateTitle = (
    <div className={getIn(errors, 'personUnawareFindOutDate') && getIn(touched, 'personUnawareFindOutDate') && styles.titleError}>
      <p><b>When did you first find out about the fine?</b></p>
      <p className={styles.subtitle}>You must submit your application within 14 days of becoming aware of the fine.</p>
    </div>
  );

  const personUnawareCanUploadSupportingDocsTitle = (
    <div className={getIn(errors, 'personUnawareCanUploadSupportingDocs') && getIn(touched, 'personUnawareCanUploadSupportingDocs') && styles.titleError}>
      <p><b>Can you upload documents to support this?</b></p>
      <p className={styles.subtitle}>
        Some examples of supporting documents are:
        <ul>
          <li>a copy of your passport or boarding pass showing you were overseas</li>
          <li>an invoice from a removalist showing that you moved house</li>
          <li>a VicRoads address change confirmation</li>
          <li>a report about mail theft at your address</li>
        </ul>
      </p>
    </div>
  );

  const personUnawareEnforcementHappenedTitle = (
    <div className={getIn(errors, 'personUnawareEnforcementHappened') && getIn(touched, 'personUnawareEnforcementHappened') && styles.titleError}>
      <p><b>Has any enforcement action already happened for the fine(s)?</b></p>
      <p className={styles.subtitle}>such as a suspension of driver licence or vehicle registration, wheel clamping or property seizure?</p>
    </div>
  );
  const personUnawareWasSomeoneElseDrivingTitle = (
    <div className={getIn(errors, 'personUnawareWasSomeoneElseDriving') && getIn(touched, 'personUnawareWasSomeoneElseDriving') && styles.titleError}>
      <p><b>Was someone else driving?</b></p>
      <p className={styles.subtitle}>Are you the person named on the infringement notice, but someone else was driving at the time of the offence? </p>
    </div>
  );

  const SubmitApplication14DaysMsg = (
    <>
      <p>Based on the information you have provided, you are not eligible to request a review under this ground.</p>
    </>
  );
  const personUnawareCanUploadSupportingDocsMessage = (
    <>
      <p>Your application may not be successful unless you provide evidence showing you did not know about the fine. </p>
    </>
  );
  const personUnawareEnforcementHappenedMessage = (
    <>
      <p>Some enforcement action(s) impacts your eligibility for an enforcement review.</p>
      <p>If enforcement action such as arrest and seizure of assets has happened, you are not eligible for a review.</p>
    </>
  );
  const personUnawareWasSomeoneElseDrivingMessage = (
    <>
      <p><b>If you have only just found out about the fine, you can apply for an infringement extension to get more time to deal with the fine.</b></p>
      <br />
      <p>If an infringement Extension is granted, you will then be able to nominate the person who was driving.</p>
      <br />
      <p>If the nomination is succesful, the fine will be withdrawn and may be re-issued.</p>
    </>
  );

  return (
    <div>
      <div className={gridStyles.form}>
        {personUnawareDateTitle}
        <div className={gridStyles.gridColHalf}>
          <div className={styles.fieldContainer}>
            <Field
              component={DateInput}
              name="personUnawareFindOutDate"
              title=""
              isMandatory
              minDate={new Date().setDate(new Date().getDate() - 14)}
              maxDate={new Date()}
              autocomplete="off"
            />
          </div>
        </div>
        <div className={styles.alertMessageBox}>
          {values.personUnawareFindOutDate !== null
            && (values.personUnawareFindOutDate < olderThan15Days || values.personUnawareFindOutDate > new Date()) && (
            <Alert
              message={SubmitApplication14DaysMsg}
              theme="error"
              title=""
              icon={ErrorIcon}
              classAlt={styles.boxheight}
              // color="black"
            />
          )}
        </div>
        {personUnawareCanUploadSupportingDocsTitle}
        <Field
          name="personUnawareCanUploadSupportingDocs"
          title=""
          component={TileRadioAccessible}
          tileData={TILE_DATA}
          orientationRow
        />
        <div className={styles.alertMessageBox}>
          {values.personUnawareCanUploadSupportingDocs === 'false' && (
            <Alert
              message={personUnawareCanUploadSupportingDocsMessage}
              theme="info"
              title=""
              icon={InfoIcon}
              classAlt={styles.boxheight}
              // color="black"
            />
          )}
        </div>
        {values.isEnforcementReviewStage && (
          <>
            {personUnawareEnforcementHappenedTitle}
            <Field
              name="personUnawareEnforcementHappened"
              title=""
              component={TileRadioAccessible}
              tileData={TILE_DATA}
              orientationRow
            />
            <div className={styles.alertMessageBox}>
              {values.personUnawareEnforcementHappened === 'true' && (
                <Alert
                  message={personUnawareEnforcementHappenedMessage}
                  theme="info"
                  title=""
                  icon={InfoIcon}
                  classAlt={styles.boxheight}
                  // color="black"
                />
              )}
            </div>
            {personUnawareWasSomeoneElseDrivingTitle}
            <Field
              name="personUnawareWasSomeoneElseDriving"
              title=""
              component={TileRadioAccessible}
              tileData={TILE_DATA}
              orientationRow
            />
            <div className={styles.alertMessageBox}>
              {values.personUnawareWasSomeoneElseDriving === 'true' && (
                <Alert
                  message={personUnawareWasSomeoneElseDrivingMessage}
                  theme="error"
                  title=""
                  icon={ErrorIcon}
                  classAlt={styles.boxheight}
                  // color="black"
                />
              )}
            </div>
          </>
        )}
        <br />
        <span><b>Things to note:</b></span>
        <ul>
          <li>
            If you moved house but you did not
            {' '}
            <a href="/Your-options/Update-your-address">
              change your authorised address with VicRoads
            </a>
            {' '}
            within 14 days of moving (as you are required to do under the law), your application may not be successful.
          </li>
          <br />
          {values.isInternalReviewStage && <li> If your application is successful you will be granted a further 21 days to deal with your fine.</li>}
          {values.isEnforcementReviewStage && <li> If your application is successful, the fine will be referred back to the enforcement agency who issued it, and the fees will be waived. The enforcement agency can decide to  withdraw the fine, issue an official warning or refer the matter to court. </li>}
        </ul>
        <ReviewAccordionFooter
          selectOptionName={FIELD_NAME}
          closeOptionName="closeTheOption"
          itemOption={PERSON_UNAWARE_FIELD_NAME}
          isSelectButtonDisabled={errorsBlockingSelection}
          validateFieldsNames={
            values.isEnforcementReviewStage
            ? ['personUnawareFindOutDate', 'personUnawareCanUploadSupportingDocs', 'personUnawareEnforcementHappened', 'personUnawareWasSomeoneElseDriving']
            : ['personUnawareFindOutDate', 'personUnawareCanUploadSupportingDocs']
          }
          isMultiSelect={false}
        />
      </div>
    </div>
  );
};

export default PersonUnawareContent;
